import moment from "moment";
const authorizationStatus = (value)=>{
switch (value){
  case 1 :return "-"
  case 2: return "en attente"
  case 3: return "Authorisé"
  case 2: return "Refusé"
}



}

export const multiDataSet = (data, totalDebit, totalCredit, beginBalance) => {
  return [
    {
      columns: [],
      data: [
        [
          {
            value: "-",
            width: { wpx: 60 },
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
          },
          {
            value: "-",
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 80 },
          }, //char width
          {
            value: "-",
            width: { wpx: 60 },
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
          },
          {
            value: "-",
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 120 },
          }, //pixels width
          {
            value: "-",
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 130 },
          },
          {
            value: "-",
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 120 },
          },
            {
            value: "-",
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 120 },
          },
          {
            value: totalDebit || 0,
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 100 },
          },
          {
            value: totalCredit ? totalCredit : 0,
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 100 },
          },
          //pixels width
          {
            value: totalDebit - totalCredit,
            style: {
              font: { sz: "13", color: { rgb: "673ab7" } },
              alignment: { horizontal: "center" },
            },
            width: { wpx: 150 },
          }, //char
          {
            value: "-",
            style: {
              alignment: { horizontal: "center" },
            },
            width: { wpx: 120 },
          },
          {
            value: "-",
            style: {
              alignment: { horizontal: "center" },
            },
            width: { wpx: 120 },
          },
          {
            value: "-",
            style: {
              alignment: { horizontal: "center" },
            },
            width: { wpx: 140 },
          },
          {
            value: "-",
            style: {
              alignment: { horizontal: "center" },
            },
            width: { wpx: 120 },
          },
        ],
      ],
    },
    {
      columns: [
        {
          title: "N° P",
          width: { wpx: 60 },
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
        },
        {
          title: "Date",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 80 },
        }, //char width

        {
          title: "Client",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 120 },
        },
        {
          title: "Numéro de passeport",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 140 },
        },

        {
          title: "Representative",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 120 },
        },
         {
          title: "status",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 140 },
        },
        {
          title: "Vol",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 140 },
        },
        {
          title: "Recettes",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 100 },
        },
        {
          title: "Dépenses",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 100 },
        },
        {
          title: "Solde Progressif",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 100 },
        },

        {
          title: "Type",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 140 },
        },
        {
          title: "Service",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 100 },
        },
        {
          title: "Caisse",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 140 },
        },
        //pixels width
        {
          title: "Observation",
          style: {
            fill: { fgColor: { rgb: "673ab7" } },
            font: { sz: "13", color: { rgb: "ffffff" } },
            alignment: { horizontal: "center" },
          },
          width: { wpx: 120 },
        }, //pixels width
      ],
      data: data.map((item) => {
        let item2 = [
          {
            value: item.sequentialNumber || "-",
            style: {
              fill: { fgColor: { rgb: "673ab7" } },
              font: { sz: "13", color: { rgb: "ffffff" } },
              alignment: { horizontal: "center" },
            },
          },
          {
            value: item.date ? moment(item.date).format("DD/MM/yyyy") : "-",
            style: {
              font: { sz: "12", color: { rgb: "222222" } },
              alignment: { horizontal: "center" },
            },
          },
          {
            value: item?.infosB2C
              ? item?.infosB2C?.fullName
              : item?.client
              ? item?.client?.name
              : "-",
            style: {
              fill: { fgColor: { rgb: "fcedbc" } },
              alignment: { horizontal: "left" },
            },
          },
          {
            value: item?.infosB2C?.passportNumber || "-",
            style: {
              fill: { fgColor: { rgb: "fcedbc" } },
              alignment: { horizontal: "left" },
            },
          },
          {
            value: item.representative ? item.representative : "-",
            style: {
              fill: { fgColor: { rgb: "fcedbc" } },
              alignment: { horizontal: "left" },
            },
          },
           {
            value: authorizationStatus(item.authorizationStatus)|| "-",
            style: {
              fill: { fgColor: { rgb: "fcedbc" } },
              alignment: { horizontal: "left" },
            },
          },
          {
            value: item.disponibilityName || "-",
            style: {
              fill: { fgColor: { rgb: "fcedbc" } },
              alignment: { horizontal: "left" },
            },
          },
          {
            value: item.debit,
            style: {
              fill: { fgColor: { rgb: "fcedbc" } },

              font: { sz: "13" },
              alignment: { horizontal: "center" },
            },
          },
          {
            value: item.credit,
            style: {
              font: { sz: "13", color: { rgb: "2590b5" } },
              alignment: { horizontal: "center" },
            },
          },
          {
            value: item.sp ? item.sp : "-",
            style: {
              font: { sz: "13", color: { rgb: "2590b5" } },
              alignment: { horizontal: "center" },
            },
          },

          {
            value: item?.operationType?.designation || "-",
            style: {
              font: {
                sz: "14",
                color: { rgb: "111111" },
              },
              alignment: { horizontal: "left" },
            },
          },
          {
            value: item?.serviceName?.toUpperCase() || "-",
            style: {
              font: {
                sz: "14",
                color: { rgb: "111111" },
              },
              alignment: { horizontal: "left" },
            },
          },

          {
            value: item?.checkout?.name?.toUpperCase() || "-",
            style: {
              font: {
                sz: "14",
                color: { rgb: "111111" },
              },
              alignment: { horizontal: "left" },
            },
          },
          {
            value: item.designation || "-",
            style: {
              font: {
                sz: "14",
                color: { rgb: "111111" },
              },
              alignment: { horizontal: "left" },
            },
          },
        ];
        return item2;
      }),
    },
  ];
};
